import React from 'react';

const FEATURES = [
    {
        title: 'Annual Report Intelligence',
        desc: 'RAG-powered Q&A over uploaded annual reports with page-level citations you can verify.',
        iconColor: 'green',
        icon: '📄',
    },
    {
        title: 'Financial Ratio Dashboards',
        desc: 'Color-coded ratio analysis with automated thresholds — profitability, leverage, liquidity at a glance.',
        iconColor: 'blue',
        icon: '📊',
    },
    {
        title: 'Forensic Risk Signals',
        desc: 'Beneish M-Score, Sloan ratio, accrual quality and more — surface red flags before they hit headlines.',
        iconColor: 'amber',
        icon: '🔍',
    },
    {
        title: 'Working Capital Cycle',
        desc: 'DSO, DIO, DPO and Cash Conversion Cycle trends with waterfall breakdowns across fiscal years.',
        iconColor: 'purple',
        icon: '🔄',
    },
    {
        title: 'Multi-hop Q&A',
        desc: 'Ask complex cross-year questions — the system reasons across multiple documents and cites every claim.',
        iconColor: 'green',
        icon: '💬',
    },
    {
        title: 'Notes & Research Workspace',
        desc: 'Attach notes, highlights, and commentary per company — your research stays organized in one place.',
        iconColor: 'blue',
        icon: '📝',
    },
];

const FeatureGrid = () => (
    <section className="lp-features" id="features">
        <p className="lp-section-label">Capabilities</p>
        <h2 className="lp-section-title">Everything you need for fundamental analysis</h2>

        <div className="lp-feature-grid">
            {FEATURES.map((f) => (
                <div className="lp-feature-card" key={f.title}>
                    <div className={`lp-feature-icon ${f.iconColor}`} aria-hidden="true">
                        {f.icon}
                    </div>
                    <h3>{f.title}</h3>
                    <p>{f.desc}</p>
                </div>
            ))}
        </div>
    </section>
);

export default FeatureGrid;
